import React, { FC } from 'react'
import { IProductDetail } from '../../../types'
import Card from '../../Card/Card'
import css from './Recomended.module.scss'

const Recomended: FC<{ product: IProductDetail }> = ({ product }) => {
  if (!product || !product.recomended || product.recomended?.length < 1) {
    return null
  }

  return (
    <section className={css.wrapper}>
      <h3 className={css.title}>С этим товаром покупают</h3>

      <ul className={css.list}>
        {product.recomended?.map((item) => (
          <Card
            key={item.id}
            element={item}
            category={item.section}
            footerClassName={css.cardFooter}
          />
        ))}
      </ul>
    </section>
  )
}

export default Recomended
